import { useEffect } from "react";
import { ThreePlanogram } from "../../store/types";
import { PlanogramBay } from "@CommonTypes/merchflow/pog/bay";
import { createThreeMesh } from "../../store/utils/three";
import { Color } from "src/elements";

interface Props {
  bay: PlanogramBay;
  bayIndex: number;
  three: ThreePlanogram;
}

export const BayVerticalLine = ({ bay, bayIndex, three }: Props) => {
  useEffect(() => {
    const dividerWidth = 100;
    const dividerX = bay.getXLeft() + bay.width - dividerWidth / 2;

    const dashHeight = 200;
    const dashGap = 200;

    const totalHeight = bay.height;
    const dashCount = Math.floor(totalHeight / (dashHeight + dashGap));

    const dashCleanups: Array<() => void> = [];

    if (bayIndex < bay.planogram.bays.length - 1) {
      for (let dashIndex = 0; dashIndex < dashCount; dashIndex++) {
        const dashY = dashIndex * (dashHeight + dashGap) + dashHeight / 2;

        const dash = createThreeMesh({
          scene: three.scene,
          width: dividerWidth,
          height: dashHeight,
          depth: bay.depth,
          x: dividerX,
          y: dashY,
          z: 0,
          color: Color.forest950,
          renderOrder: 3,
        });

        dashCleanups.push(dash.cleanUp);
      }
    }

    return () => {
      dashCleanups.forEach((fn) => fn());
    };
  }, [bay, bayIndex, three]);

  return null;
};
